
























import { Component, Vue, Prop, Emit } from "vue-property-decorator";
const defaultClass =
  "h-full flex flex-grow-0 items-center justify-center rounded";

@Component
export default class AppButton extends Vue {
  @Prop({ default: false }) loading: Boolean;
  @Prop() type: string;
  @Prop() btnClass: string;
  @Prop() rounded: string;
  @Prop() small: string;
  @Prop() large: string;
  @Prop() primary: string;
  @Prop() secondary: string;
  @Prop() success: string;
  @Prop() info: string;
  @Prop() gray: string;
  @Prop() danger: string;

  @Emit("click")
  async onClick(e: any) {}

  get customClass(): string {
    let computed = defaultClass;

    // Round
    if (this.rounded !== undefined) {
      computed += " rounded-full";
    }

    // Button State
    if (this.primary !== undefined) {
      computed +=
        " bg-blue-600 hover:bg-blue-600 text-white border border-blue-600 shadow";
    } else if (this.secondary !== undefined) {
      computed +=
        " bg-white hover:bg-gray-100 text-gray-800 border border-gray-300";
    } else if (this.info !== undefined) {
      computed +=
        " bg-blue-600 hover:bg-blue-600 text-white border border-blue-600 shadow";
    } else if (this.success !== undefined) {
      computed +=
        " bg-green-600 hover:bg-green-600 text-white border border-green-600 shadow";
    } else if (this.danger !== undefined) {
      computed +=
        " bg-red-700 hover:bg-red-700 text-white border border-red-700 shadow";
    } else if (this.gray !== undefined) {
      computed +=
        " bg-gray-200 hover:bg-gray-300 text-white border border-gray-700";
    } else {
      computed +=
        " bg-white hover:bg-gray-100 text-gray-600 border border-gray-300";
    }

    // Button Size
    if (this.small !== undefined) {
      computed += " py-1 px-3 h-8 text-sm";
    } else if (this.secondary !== undefined) {
      computed += " py-2 px-2";
    } else if (this.large !== undefined) {
      computed += " py-2 px-8";
    } else {
      computed += " py-2 px-2";
    }
    return computed;
  }
}
